import React from 'react';

import { isMobilePhone, getNodeFromNodeObjsWithPrId,} from '../../library/calc';

class RedrawCanvasTree extends React.Component {

  componentDidMount(){

     console.log(`%c RedrawCanvasTree-componentDidMount`, [ // bookmarkPleaseRemove RedrawCanvasTree
       'color: white',
       'background: blue',
       'font-size: 14px',
       'border: 5px solid red',
       'padding: 10px',
       ].join(';'));


    let {
      callSetPageProfile,
      setDidRequestLoadTreeToTrue,
      fetchPreferences,
      fetchTree,
      nodeObjs,
      prIdToRedraw,
      prIdToTeleport,
      setPrId,
      setPushToHistory,
      showProgressIndicator,
      zoomOutFromMobileFlipCard,
      resetReloadCanvasTree,
      unionIdDualPedigreeChoice,
      fetchPrunesOnlyAfterDelay,
      gatherNodesToFetchMoreData,
      postPoster,
      hideProgressIndicator,
    } = this.props;

    const setUpThenFetchSaga = () => {

      if(typeof(window.$j) !== 'undefined') window.$j('.add-cancel').click(); // Closes add node form

      showProgressIndicator({fromWhere: 'RedrawCanvasTree->callback'});
      const fromWhere = 'RedrawCanvasTree';

      setDidRequestLoadTreeToTrue('redraw component');

      if (typeof(unionIdDualPedigreeChoice) !== 'undefined'){

        setPrId(prIdToRedraw, fromWhere);

        /*
        dualPedigreeMode
         */

        const callFetchTree = () => {
          fetchTree({unionId: unionIdDualPedigreeChoice, fromWhere: 'RedrawCanvasTree'});
        }


        postPoster({
          action: 'redrawCanvasTree',
          focusPrId: prIdToRedraw,
          unionId: unionIdDualPedigreeChoice,
          callFetchTree,
        })

      } else {

        setPrId(prIdToRedraw, fromWhere);
        const callbackAfterFetchTree = (nodeObjs)=>{

          hideProgressIndicator()

          if(typeof(window.$j) !== 'undefined') window.$j('.ant-notification-notice-close-x').click();
          callSetPageProfile(prIdToRedraw, nodeObjs, 'setUpThenFetchSaga');

          const { newPrunesObj } = gatherNodesToFetchMoreData({all: false,});
          fetchPrunesOnlyAfterDelay({newPrunesObj})

        }

        fetchTree({callback: callbackAfterFetchTree, prIdToTeleport, unionId: unionIdDualPedigreeChoice, fromWhere: 'RedrawCanvasTree'});
        setPushToHistory();

      }

      const callbackAfterPreferenceFetch = ()=>{}
      fetchPreferences({callbackAfterPreferenceFetch});

    }

    const node = getNodeFromNodeObjsWithPrId({nodeObjs, prId: prIdToRedraw, fromWhere: 'RedrawCanvasTree'});

    setTimeout(() => {

      resetReloadCanvasTree();

      if(isMobilePhone()){

        zoomOutFromMobileFlipCard({
          node,
          callback: setUpThenFetchSaga
        });
      } else{

        setUpThenFetchSaga();
      }
    }, 800); // Keep timeout so transform-x transitions from flip-panel can finish


  }

  render() {

    return (
        <div style={{display: 'none'}}>
          Redraw Tree Hidden Component
        </div>
    );
  }
}

export default RedrawCanvasTree;

